import {Connection} from './connection';
import {DB} from '../db';
import {MQ} from './mq';
import {KKAuth} from './index';

// 上下文 用途，贯穿事件
export default class Context {
    private readonly _id: number;
    private readonly _auth: KKAuth;
    private readonly _db: DB;
    private readonly _conn: Connection;
    private readonly _mq: MQ;
    private _isStop: boolean;

    constructor(auth: KKAuth, db: DB, conn: Connection, mq: MQ) {
        this._id = newID();
        this._auth = auth;
        this._db = db;
        this._conn = conn;
        this._mq = mq;
        this._isStop = false;
    }

    public get mq(): MQ {
        return this._mq;
    }

    public get id(): number {
        return this._id;
    }

    public get uid(): number {
        return this._auth.uid;
    }

    public get appkey(): string {
        return this._auth.appkey;
    }

    public get db(): DB {
        return this._db;
    }

    public get conn(): Connection {
        return this._conn;
    }

    public get stop(): boolean {
        return this._isStop;
    }

    public set stop(v: boolean) {
        this._isStop = v;
    }
}

let g_context_id: number = 0;
function newID(): number {
    if (g_context_id <= 0) {
        g_context_id = new Date().getTime();
        return g_context_id;
    }
    g_context_id++;
    return g_context_id;
}
